import { render } from "./VoiceTextComponent.vue?vue&type=template&id=2df7d934&scoped=true"
import script from "./VoiceTextComponent.vue?vue&type=script&lang=js"
export * from "./VoiceTextComponent.vue?vue&type=script&lang=js"

import "./VoiceTextComponent.vue?vue&type=style&index=0&id=2df7d934&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Murilo\\Documents\\app-construp-cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df7d934"]])

export default __exports__